<template>
  <div class="showdata">
    <vue-seamless-scroll :data="Docdata" :class-option="defaultOption">
      <ul>
        <li v-for="(item, index) in Docdata" :key="index">
          {{ item.userZh }}--{{ item.count }}
        </li>
      </ul>
    </vue-seamless-scroll>
  </div>
</template>

<script>
import { reqUserDocList } from "@/network/homePage";
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  name: "showData",
  components: {
    vueSeamlessScroll,
  },
  data() {
    return {
      Docdata: [],
    };
  },
  // 计算属性
  computed: {
    defaultOption() {
      return {
        step: 0.3, // 数值越大速度滚动越快
        limitMoveNum: this.Docdata.length, // 开始无缝滚动的数据量
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  methods: {
    async getUserDocList() {
      let { data } = await reqUserDocList();
      if (data.code == 200) {
        this.Docdata = data.data;
      }
    },
  },
  created() {
    this.getUserDocList();
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.showdata {
  width: 100%;
  height: 100%;
  ul {
    padding: 0;
    margin: 0;
    color: rgba(255, 255, 255, 0.6);
    font-size: 18px;
    li {
      width: 100%;
      box-sizing: border-box;
      list-style: none;
      height: 40px;
      line-height: 40px;
      border: 1px solid rgba(25, 186, 139, 0.17);
      padding-left: 30px;
      margin-bottom: 13px;
    }
  }
}
</style >